import GATSBY_COMPILED_MDX from "/home/runner/work/capsulecrm.com/capsulecrm.com/src/mdxPages/integrations/google-calendar/index.en.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import MainLayout from "@/layouts/MainLayout";
import MDXContentWrapper from "@/components/MDXContentWrapper";
import IntegrationPageHeader from "@/components/IntegrationPageHeader";
import IntegrationCarousel from "@/components/IntegrationCarousel";
import Longform from "@/components/Longform";
import SharedHead from "@/components/SharedHead";
import IntegrationNavigation from "@/components/IntegrationNavigation";
import {Link, useTranslation} from "@zestia/gatsby-plugin-react-i18next";
import useHeadTranslation from "@/hooks/use-head-translation";
export const Head = props => {
  const {data} = props;
  const {t} = useHeadTranslation(props);
  return React.createElement(SharedHead, Object.assign({}, props, {
    title: `${data.mdx.frontmatter.title} | ${t("integrations.integrations")}`,
    description: data.mdx.frontmatter.short_description,
    noIndex: data.mdx.frontmatter.hidden
  }));
};
const IntegrationPageLayout = ({data, borderClass, children}) => {
  const {t} = useTranslation();
  const {frontmatter, fields: {availableSlugs}} = data.mdx;
  borderClass = () => {
    if (frontmatter.carousel_items === null) {
      return "section--top-border-black pt-10";
    } else return "";
  };
  return React.createElement(MainLayout, {
    showNav: false,
    trackingData: {
      content_category: "integrations"
    }
  }, React.createElement(IntegrationNavigation, {
    availableSlugs: availableSlugs
  }), React.createElement("section", {
    className: "pt-20 container-fluid row"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement("div", {
    className: "mb-10"
  }, React.createElement(Link, {
    to: "/integrations/",
    className: "text-link text-link--arrow-before mb-10"
  }, t("integrations.navigation.back-to-all"))), React.createElement(IntegrationPageHeader, {
    data: data
  }), frontmatter.carousel_items && React.createElement(IntegrationCarousel, {
    data: frontmatter.carousel_items
  }), React.createElement("div", {
    className: `col-xs-12 row ${borderClass()}`
  }, React.createElement("div", {
    className: "col-md-7"
  }, React.createElement(Longform, null, React.createElement(MDXContentWrapper, null, children))), React.createElement("aside", {
    className: "integration-page__aside col-md-4 col-md-offset-1"
  }, frontmatter.who_can_use && React.createElement("div", {
    className: "mb-10"
  }, React.createElement("h5", null, frontmatter.who_can_use.title), React.createElement("p", null, frontmatter.who_can_use.text)), frontmatter.available_on && React.createElement("div", null, React.createElement("p", {
    className: "mb-1 p--sm"
  }, t("integration-layout.available-on")), React.createElement("p", {
    className: "mb-6"
  }, React.createElement("strong", null, frontmatter.available_on))), frontmatter.integration_categories && React.createElement("div", null, React.createElement("p", {
    className: "mb-1 p--sm"
  }, t("integration-layout.category")), frontmatter.integration_categories.map(category => React.createElement("div", {
    key: category.slug
  }, React.createElement(Link, {
    to: `/integrations/?category=${category.slug}`,
    className: "text-link text-link--arrow"
  }, React.createElement("strong", null, category.name))))), frontmatter.integration_requirements && React.createElement("div", null, React.createElement("p", {
    className: "mb-1 mt-6 p--sm"
  }, t("integration-layout.requirements")), frontmatter.integration_requirements.map(requirement => React.createElement("div", {
    key: requirement.name
  }, React.createElement("a", {
    href: requirement.url,
    className: "mb-2 text-link text-link--arrow"
  }, React.createElement("strong", null, requirement.name))))))))));
};
export const query = graphql`
  query ($id: String!) {
    ...Locales

    mdx(id: { eq: $id }) {
      body
      id
      fields {
        availableSlugs {
          lang
          slug
        }
      }
      frontmatter {
        title
        image
        short_description
        long_description
        support_url
        who_can_use {
          title
          text
        }
        available_on
        integration_categories {
          name
          slug
        }
        integration_requirements {
          name
          url
        }
        collections {
          name
          slug
        }
        bg_color
        icon_color
        hidden
        carousel_items {
          image {
            alt
            src {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, formats: AUTO)
              }
            }
          }
          video {
            youtube_url
            wistia_video_id
            wistia_video_poster
          }
        }
      }
    }
  }
`;
IntegrationPageLayout
export default function GatsbyMDXWrapper(props) {
  return React.createElement(IntegrationPageLayout, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
